import { MIME_TYPES } from '@shared/components';

export const ACCEPTED_FILE_TYPES: string[] = [MIME_TYPES.jpeg, MIME_TYPES.png, MIME_TYPES.pdf];
export const MAX_FILE_LENGTH = 4;
